var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsString } from 'class-validator';
/**
 * Response of the public session exchange: a short-lived, office-location
 * scoped signed session token the widget then carries in a request header on
 * every subsequent public call. The token is returned in the response body,
 * never in a URL or query string.
 */
export class EmbedSessionResponseDto {
    sessionToken;
    expiresAt;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], EmbedSessionResponseDto.prototype, "sessionToken", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], EmbedSessionResponseDto.prototype, "expiresAt", void 0);
//# sourceMappingURL=embed-session.response.dto.js.map